import firebaseAnalytics from './firebaseSetup';
export var WalletMicrositeAnalyticsEvent;
(function (WalletMicrositeAnalyticsEvent) {
    WalletMicrositeAnalyticsEvent["CONTACT_INFO_SCREEN_SAVE_CLICK"] = "WalletMicrositeAnalyticsEvent.CONTACT_INFO_SCREEN_SAVE_CLICK";
    WalletMicrositeAnalyticsEvent["BILLING_ADDRESS_SCREEN_SAVE_CLICK"] = "WalletMicrositeAnalyticsEvent.BILLING_ADDRESS_SCREEN_SAVE_CLICK";
    WalletMicrositeAnalyticsEvent["CARD_INFO_SCREEN_SAVE_CLICK"] = "WalletMicrositeAnalyticsEvent.CARD_INFO_SCREEN_SAVE_CLICK";
})(WalletMicrositeAnalyticsEvent || (WalletMicrositeAnalyticsEvent = {}));
export { firebaseAnalytics };
